import { StyleSheet } from 'aphrodite';
import { baseStyles } from '../../../../web/styles/styles';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, spacing } = THEME;

export const mobileStyleSheet = StyleSheet.create({
	fullPageContainer: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: 1000,
		backgroundColor: colors.background.light,
		display: 'flex',
		flexDirection: 'column',
		height: '100vh',
		width: '100vw',
		overflow: 'hidden',
		boxSizing: 'border-box',
	},
	aiToggleIconImage: {
		height: 24,
		width: 24,
	},
	header: {
		alignItems: 'center',
		background: 'linear-gradient(158deg, #009FFF, #0066FF)',
		color: colors.background.light,
		display: 'flex',
		justifyContent: 'space-between',
		padding: `12px ${spacing.md}px`,
		fontSize: 16,
		fontWeight: 600,
		flexShrink: 0,
	},
	closeButton: {
		height: spacing.lg,
		width: spacing.lg,
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		overflowY: 'auto',
		overflowX: 'hidden',
		minHeight: 0,
		width: '100%',
		boxSizing: 'border-box',
	},
	navigationRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		borderBottom: `1px solid ${colors.border.light}`,
		backgroundColor: colors.background.main,
	},
	userInfo: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		flex: 1,
		margin: '0 16px',
	},
	userInfoContent: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: spacing.sm,
	},
	navAvatar: {
		height: spacing.xl,
		width: spacing.xl,
		marginRight: spacing.sm,
	},
	userDetails: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
	},
	userName: {
		fontSize: 14,
		fontWeight: 600,
		color: colors.text.main,
		lineHeight: 1.2,
	},
	userPostedTime: {
		fontSize: 12,
		color: colors.text.light,
		lineHeight: 1.2,
	},
	navButton: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: spacing.sm,
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		borderRadius: 4,
		':hover': {
			backgroundColor: colors.background.light,
		},
	},
	progressText: {
		color: colors.text.light,
		fontSize: 12,
		fontWeight: 500,
	},
	location: {
		color: colors.primary.main,
		fontSize: 12,
		marginBottom: 4,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
		gap: 4,
		maxWidth: '100%',
		textAlign: 'center',
	},
	locationIcon: {
		height: 12,
		width: 12,
		flexShrink: 0,
	},
	rating: {
		display: 'flex',
		alignItems: 'center',
	},
	ratingStar: {
		height: 16,
		width: 16,
	},
	reviewSection: {
		padding: spacing.md,
		borderBottom: `1px solid ${colors.border.light}`,
		maxHeight: 100,
		overflowY: 'auto',
		flexShrink: 0,
	},
	reviewText: {
		fontSize: 14,
		lineHeight: 1.4,
		margin: 0,
		textAlign: 'left',
		color: colors.text.main,
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},
	emptyComment: {
		color: colors.text.light,
		fontStyle: 'italic',
	},
	responseRow: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minHeight: 0,
		overflow: 'hidden',
	},
	responseRowCompact: {
		flex: 1,
		minHeight: 0,
	},
	responseContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: spacing.md,
		borderBottom: `1px solid ${colors.border.light}`,
	},
	responseContainerCompact: {
		padding: '12px 16px',
	},
	responseTitle: {
		margin: '0 0 12px 0',
		fontSize: 16,
		fontWeight: 600,
		color: colors.text.main,
	},
	textArea: {
		...baseStyles.textField,
		'-webkit-appearance': 'none',
		'::placeholder': {
			color: colors.text.light,
		},
		':focus': {
			outline: `2px solid ${colors.primary.main}`,
			outlineOffset: 1,
		},
		resize: 'vertical',
		minHeight: 120,
		fontSize: 16,
		lineHeight: 1.4,
		marginBottom: spacing.md,
		flex: 1,
	},
	textAreaCompact: {
		minHeight: 80,
		marginBottom: spacing.sm,
	},
	errorContainer: {
		backgroundColor: '#fef2f2',
		border: `1px solid ${colors.danger.main}`,
		borderRadius: 4,
		color: colors.danger.main,
		fontSize: 12,
		marginBottom: spacing.md,
		padding: spacing.sm,
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		marginTop: spacing.sm,
	},
	aiToggleContainer: {
		padding: '16px',
		borderBottom: `1px solid ${colors.border.light}`,
	},
	aiAssistantSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	aiUserInfo: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	aiAvatar: {
		height: 32,
		width: 32,
	},
	aiUserName: {
		fontSize: 14,
		fontWeight: 600,
		color: colors.text.main,
		flex: 1,
	},
	aiPromptContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		marginLeft: 44,
	},
	aiPromptText: {
		fontSize: 14,
		color: colors.text.main,
	},
	aiCraftButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		backgroundColor: colors.primary.main,
		border: 'none',
		borderRadius: 8,
		color: colors.background.light,
		fontSize: 14,
		fontWeight: 500,
		cursor: 'pointer',
		width: '100%',
		':hover': {
			backgroundColor: colors.primary.dark,
		},
	},
	aiExpandedContent: {
		marginLeft: 44,
		marginTop: spacing.sm,
		maxHeight: 300,
		overflow: 'hidden',
	},
	aiToggleButton: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		backgroundColor: '#f0f7ff',
		border: `1px solid ${colors.primary.main}`,
		borderRadius: 8,
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 500,
		color: colors.primary.main,
		transition: 'all 0.2s ease',
		':hover': {
			backgroundColor: '#e6f3ff',
		},
		':active': {
			transform: 'scale(0.98)',
		},
	},
	aiToggleIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	aiToggleText: {
		flex: 1,
		textAlign: 'left',
	},
	aiToggleChevron: {
		fontSize: 12,
		color: colors.text.light,
		transition: 'transform 0.2s ease',
		marginLeft: 8,
	},
	aiToggleChevronExpanded: {
		transform: 'rotate(180deg)',
	},
	assistantContainer: {
		flexShrink: 0,
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: colors.background.light,
	},
	aiExpandedContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		flex: 1,
		minHeight: 300,
		overflow: 'hidden',
	},
	aiHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		backgroundColor: '#f0f7ff',
		borderBottom: `1px solid ${colors.border.light}`,
		flexShrink: 0,
	},
	aiHeaderContent: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	aiHeaderIcon: {
		height: 20,
		width: 20,
	},
	aiHeaderText: {
		fontSize: 14,
		fontWeight: 600,
		color: colors.primary.main,
	},
	aiCloseButton: {
		height: 20,
		width: 20,
	},
	aiContentContainer: {
		flex: 1,
		overflow: 'hidden',
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
	},
	successScreen: {
		height: 300,
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		padding: 24,
		textAlign: 'center',
	},
});
